<div
  style="margin: 1em; display:flex;justify-content:center;align-items:center; flex-direction: column;"
>
  <div
    style="margin: 1em; padding: 1em; display: inline-block; text-align: center; border: 1px solid black; border-radius: 8px;"
  >
    Diese Seite funktioniert leider nicht in <b>Internet Explorer 11</b>.
    <br />
    Bitte verwende einen anderen Browser, z.B.
    <a
      href="https://support.microsoft.com/de-de/microsoft-edge/herunterladen-der-neuen-auf-chrome-basierenden-version-von-microsoft-edge-0f4a3dd7-55df-60f5-739f-00010dba52cf"
      >Microsoft Edge</a
    >, <a href="https://www.mozilla.org/de/firefox/new/">Mozilla Firefox</a>
    oder
    <a href="https://www.google.com/intl/de_de/chrome/">Google Chrome</a>.
  </div>
  <div
    style="margin: 1em; padding: 1em; display: inline-block; text-align: center; border: 1px solid black; border-radius: 8px;"
  >
    This page does not support <b>Internet Explorer 11</b>.
    <br />
    Please use another browser, e.g.
    <a href="https://www.microsoft.com/en-US/edge">Microsoft Edge</a>,
    <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a>
    or
    <a href="https://www.google.com/intl/en_US/chrome/">Google Chrome</a>.
  </div>
</div>
